import { useEffect } from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import { useTranslation } from 'react-i18next'
import ImageWithSkeleton from '../../components/ImageWithSkeleton.js'
import { fadeInAnimation } from '../../utils/cssFunctions'
import HelmetMeta from '../../layouts/HelmetMeta.js'

export default function Sponsors () {
  const { t } = useTranslation('others')
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container sx={{ mt: 12, mb: 4 }} maxWidth='lg'>
      <HelmetMeta
        {...{
        title: t('sponsors.metaTitle'),
        description: t('sponsors.metaDescription'),
        image: '/img/races/i/ramadan-race.jpg'
      }}
      />
      <Typography
        sx={{
          fontSize: { xs: '1.5rem', md: '2rem' },
          fontWeight: 700,
          textAlign: 'center',
          mb: 6,
          mt: 2,
          ...fadeInAnimation
        }}
      >
        {t('sponsors.heading')}
      </Typography>

      <Typography>
        {t('sponsors.paragraph1')}
      </Typography><br />
      <Typography>
        {t('sponsors.paragraph2a')} {t('sponsors.paragraph2b')}
      </Typography>
      <Button
        component={Link}
        href='mailto:info@peakssports.com'
        variant='outlined'
        color='primary'
        target='_blank'
        sx={{ color: 'white', mt: 2, '&:hover': { color: '#ddd' } }}
        startIcon={<EmailOutlinedIcon />}
      >
        {t('sponsors.contact')}
      </Button>
      <Divider sx={{ my: 5 }}/>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6, md: 5 }}>
          <ImageWithSkeleton src='https://d1hi0tbu2kom2c.cloudfront.net/img/salomon.png' ratio={0.71} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 7 }}>
          <Typography variant='h5'>
            {t('sponsors.salomonTitle')}
          </Typography><br /><br />
          <Typography>
            {t('sponsors.salomonParagraph')}
          </Typography>
        </Grid>
      </Grid>

      <Divider sx={{ my: 5 }}/>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6, md: 7 }}>
          <Typography variant='h5'>
            {t('sponsors.salhaTitle')}
          </Typography><br /><br />
          <Typography>
            {t('sponsors.salhaParagraph')}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 5 }} sx={{ textAlign: 'center' }}>
          <Box component='img' src='https://d1hi0tbu2kom2c.cloudfront.net/img/salha-albasti.png' sx={{ width: 120 }} />
        </Grid>
      </Grid>

    </Container>
  )
}
